/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Costcenter1Inputs */

const en__field_costcenter1 = /** @type {(inputs: _Field_Costcenter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost center`)
};

const de__field_costcenter1 = /** @type {(inputs: _Field_Costcenter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenstelle`)
};

/**
* | output |
* | --- |
* | "Cost center" |
*
* @param {_Field_Costcenter1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_costcenter1 = /** @type {((inputs?: _Field_Costcenter1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Costcenter1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_costcenter1(inputs)
	return de__field_costcenter1(inputs)
});
export { _field_costcenter1 as "_field_costCenter" }